import script from "./StudentPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentPanel.vue?vue&type=script&setup=true&lang=js"

import "./StudentPanel.vue?vue&type=style&index=0&id=6412846d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6412846d"]])

export default __exports__